
export const SLIDER_RADIUS = 20

export const ON_SLIDER_UPDATE_RENDERER = "onSliderUpdateRendering"
